/**
 * Import Data date filter — matches Angular `import-data.component.ts`:
 * `daterange: { fromDt: moment().startOf('month'), toDt: moment().endOf('month') }`.
 */
import { endOfMonth, startOfMonth } from 'date-fns'
import type { ImportFilterState } from '../types/importData'

export function getDefaultImportDateRange(): { dateStart: Date; dateEnd: Date } {
  const now = new Date()
  return {
    dateStart: startOfMonth(now),
    dateEnd: endOfMonth(now),
  }
}

export function createDefaultImportFilterState(): ImportFilterState {
  const { dateStart, dateEnd } = getDefaultImportDateRange()
  return {
    type: '',
    listed: '',
    pmc_import_type: '',
    fk_team_id: '',
    dateStart,
    dateEnd,
  }
}
